import React, { useCallback, useEffect, useState } from "react";
import { Row, Col, Tabs, Spin, Modal } from "antd";
import { getApis } from "../../Common/apis";
import {
  vehicleDetailsApiUrl,
  // imeiListApiUrl,
  vehicleTripSummaryUrl,
  testRideListUrl,
  vehiclePartAttributeApiUrl,
} from "../../Common/endpoints";
import { useDispatch, useSelector } from "react-redux";
import { setVehicleDetails, setHBTestRunningStatus } from "../../../reducers/eolSlice";
import {
  setCurrentStep,
  setRideDetails,
  setSelectedTab,
  setTestId,
  setTripSummary,
  setPaginationDetails,
  setTestRideHistory,
  setRideHistoryFlag,
} from "../../../reducers/testRideSlice";
import RideHistory from "./RideHistory";
import RideStatistics from "./RideStatistics";
import { HistoryOutlined } from "@ant-design/icons";
import AddTestRide from "./AddRide";
import { formatDateAndTime } from "../../Common/Utils";
import { useRequiredAccess } from "../../../hooks/useRequiredAccess"
import { ORG_TYPES, ROLES } from "../../Common/Constants";
import { setNavStop } from "../../../reducers/authSlice";
import { EOLConfirmationPopup } from "../../Common/confirmationPopup";
import { toast } from "react-toastify";
import { setPageLoader } from "../../../reducers/loaderSlice";
import VEHICLE from "../../../assets/images/icons/outline-vehicle.png";
const vehicleIcon = <img src={VEHICLE} alt="#" className="vehicle-loader" />;

const TestRides = () => {
  const dispatch = useDispatch();
  const testRide = useSelector((state) => state.testRide);
  // const eol = useSelector((state) => state.eol);
  // const vehicleFilter = useSelector((state) => state.eol.vehicleFilter);
  const selectedTab = testRide?.selectedTab;
  const tripSummary = testRide?.tripSummary;
  const testId = testRide?.testId;
  const [vehicle, setVehicle] = useState({});
  // const [imei, setImei] = useState("");
  const [rearTyreDiameter, setRearTyreDiameter] = useState(null);
  const [batteryDetails, setBatteryDetails] = useState({});
  const navStop = useSelector((state) => state.auth)?.navStop;
  const [modal, contextHolder] = Modal.useModal();
  const authToken = localStorage.getItem("authToken");
  const [loadingTxt, setLoadingTxt] = useState("Generating...");
  const checkAccess = useRequiredAccess(
    [
      ROLES.ADMIN,
      ROLES.EXECUTIVE,
      ROLES.TEST_RIDE_ENGINEER,
      ROLES.FLEET_MANAGER,
    ],
    [ORG_TYPES.ADMINISTRATOR, ORG_TYPES.MANUFACTURER]
  );

  const paginationDetails = useSelector(
    (state) => state.testRide?.paginationDetails
  );

  const getVehiclePartAttribite = useCallback(async () => {
    await getApis(
      vehiclePartAttributeApiUrl,
      {
        imei: vehicle?.vehImei,
        partType: "REAR_TYRE",
      },
      authToken
    )
      .then((response) => {
        setRearTyreDiameter(
          response?.data?.attributes?.rearTyreDiameter || null
        );
      })
      .catch((e) => console.log(e.response?.data?.message));
  }, [authToken, vehicle]);

  const getVehicleBatteryDetails = useCallback(async () => {
    await getApis(
      vehiclePartAttributeApiUrl,
      {
        imei: vehicle?.vehImei,
        partType: "BATTERY",
      },
      authToken
    )
      .then((response) => {
        setBatteryDetails({
          manufacturer: response?.data?.manufacturerName,
          model: response?.data?.modelName,
          capacity: response?.data?.attributes?.fullCapacity,
        });
      })
      .catch((e) => console.log(e.response?.data?.message));
  }, [authToken, vehicle]);

  const getRideHistoryData = useCallback(async () => {
    await getApis(
      testRideListUrl,
      {
        imei: vehicle?.vehImei,
        page: paginationDetails?.current - 1,
        size: paginationDetails?.pageSize,
        sort: "id,desc",
      },
      authToken
    )
      .then((res) => {
        if (res.status === 200) {
          dispatch(
            setTestRideHistory({
              list: res?.data?.content,
              total: res?.data?.totalElements,
            })
          );
          dispatch(setRideHistoryFlag(null));
        }
      })
      .catch((e) => console.log(e));
  }, [authToken, dispatch, vehicle, paginationDetails]);

  useEffect(() => {
    checkAccess();
    if (vehicle?.vehImei) {
      getRideHistoryData();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [getRideHistoryData, vehicle?.vehId]);

  // const getImeiList = useCallback(async () => {
  //   const response = await getApis(imeiListApiUrl, { filter: vehicleFilter?.name, search: vehicleFilter?.search }, authToken);
  //   // dispatch(setImeiList(response?.data));
  //   dispatch(setVehicleFilter({...vehicleFilter, list: response?.data}));
  //   setImei(response?.data?.[0]);

  //   // eslint-disable-next-line
  // }, [authToken, vehicleFilter?.name, dispatch]);

  const getVehicleDetails = useCallback(async () => {
    dispatch(setVehicleDetails({}));
    await getApis(
      vehicleDetailsApiUrl,
      {
        imei: vehicle?.vehImei,
      },
      authToken
    ).then((response) => {
      dispatch(setVehicleDetails(response?.data));
      dispatch(setTestId(response?.data?.previousTests?.test_ride));
      dispatch(setPageLoader(null));
    }).catch((e)=>{
      console.log(e.response?.data?.message);
      dispatch(setPageLoader(null));
    })
  }, [authToken, dispatch, vehicle]);

  const getTripSummary = useCallback(async () => {
    setLoadingTxt("Checking...");
    const response = await getApis(
      vehicleTripSummaryUrl,
      { testId: testId },
      authToken
    );
    if (response?.data?.tripModeStats && testRide?.rideHistoryFlag === testId) {
      getRideHistoryData();
    }
    dispatch(setTripSummary(response?.data));
    if (response?.data?.message === "FAILED" && selectedTab === "rideStatistics") {
      toast.error("The latest test ride has failed. Please try again.");
      dispatch(setSelectedTab("addTestRide"));
    }
    if (response?.data?.message === "ABORTED" && selectedTab === "rideStatistics") {
      toast.error("The test ride was Aborted. Please try again.");
      dispatch(setSelectedTab("addTestRide"));
    }
    setLoadingTxt("Generating...");
  }, [
    authToken,
    dispatch,
    testId,
    selectedTab,
    getRideHistoryData,
    testRide?.rideHistoryFlag,
  ]);

  useEffect(() => {
    let intervalId;
    if (Object.keys(tripSummary)?.length === 0 && testId && testId !== 0) {
      getTripSummary();
    } else if (tripSummary && tripSummary?.message === "IN_PROGRESS") {
      dispatch(setNavStop(true));
      intervalId = setInterval(() => {
        getTripSummary();
      }, 10000);
    } else if (tripSummary?.message !== "IN_PROGRESS") {
      dispatch(setNavStop(false));
    }

    return () => clearInterval(intervalId);
    // eslint-disable-next-line
  }, [getTripSummary, testId, tripSummary]);

  useEffect(() => {
    dispatch(setSelectedTab("addTestRide"));
    if (vehicle?.vehImei && vehicle?.vehImei !== "") {
      dispatch(setPageLoader("refresh"));
      getVehicleDetails();
      getVehiclePartAttribite();
      getVehicleBatteryDetails();
    }
    // eslint-disable-next-line
  }, [getVehicleDetails, getVehiclePartAttribite, vehicle]);

  const onChangeVehicle = (_,value) => {
    setVehicle(value);
    // dispatch(setVehicleDetails({}));
    dispatch(setSelectedTab(selectedTab));
    dispatch(setCurrentStep(0));
    dispatch(setRideDetails({}));
    dispatch(setTestId(0));
    dispatch(setTripSummary({}));
    dispatch(setPaginationDetails({ current: 1 }));
    dispatch(setHBTestRunningStatus(false));
  };

  const onChangeTab = async (key) => {
    if (selectedTab === "rideStatistics") {
      const confirmation = navStop
        ? await modal.confirm(EOLConfirmationPopup)
        : true;
      if (confirmation) {
        dispatch(setSelectedTab(key));
        dispatch(setNavStop(false));
      }
    } else {
      dispatch(setSelectedTab(key));
      if (key === "rideStatistics" && tripSummary?.message === "IN_PROGRESS") {
        dispatch(setNavStop(true));
      }
    }
  };

  const items = [
    {
      key: "addTestRide",
      label: "Add Test Ride",
      children: (
        <AddTestRide
          onChangeVehicle={onChangeVehicle}
          batteryDetails={batteryDetails}
          vehicle={vehicle}
        />
      ),
    },
    {
      key: "rideHistory",
      label: "Ride History",
      children: <RideHistory onChangeVehicle={onChangeVehicle} vehicle={vehicle} />,
    },
    {
      key: "rideStatistics",
      label: "Ride Analytics",
      className: "ride-statistics",
      children:
        <Spin
          tip={loadingTxt}
          indicator={vehicleIcon}
          spinning={tripSummary?.message === "IN_PROGRESS"}
          className="hv50 flex-center"
        >
          <RideStatistics
            onChangeVehicle={onChangeVehicle}
            vehicle={vehicle}
            rearTyreDiameter={rearTyreDiameter}
          />
        </Spin>
    },
  ];

  const renderLastRecordedTime = () => {
    if (selectedTab === "rideStatistics") {
      return (
        <div className="mobile-hide" data-testid={"test-ride-time"}>
          <HistoryOutlined className="mr05" />
          {formatDateAndTime(tripSummary?.recordedTime)}
        </div>
      );
    }
  };

  return (
    <Row>
      <Col span={24}>
        <Tabs
          activeKey={selectedTab}
          items={items}
          onChange={onChangeTab}
          tabBarExtraContent={renderLastRecordedTime()}
        />
      </Col>
      {contextHolder}
    </Row>
  );
};

export default TestRides;
